<template>
  <div class="container py-5">
    <div class="buttons">
      <router-link 
        class="button is-primary"
        :to="{ name: 'TicketMaker' }">
        Create New Ticket
      </router-link>
    </div>

    <article 
      v-if="tickets.length == 0" 
      class="message is-info is-fullwidth">
      <div class="message-body">
        <span v-if="user.role == 'office-manager'">
          There are no tickets.
        </span>
        <span v-else>
          You have not submitted any tickets.
        </span>
      </div>
    </article>

    <table v-else class="table is-fullwidth is-hoverable is-clickable">
      <thead>
        <tr>
          <th v-for="(header, headerIndex) in headers" :key="headerIndex">
            {{ header.label }}
          </th>
          <th v-if="editable"></th>
        </tr>
      </thead>
      <tbody>
        <tr 
          class="v-centered"
          v-for="ticket in tickets" 
          @click="updateTicket(ticket)"
          :key="ticket.id">
          <td>
            {{ format(parse(ticket.created_on)) }}
          </td>
          <td>
            {{ diffToday(parse(ticket.created_on))}}
          </td>
          <td>
            {{ ticket.created_user.display_name }}
          </td>
          <td>
            {{ ticket.admin_user.display_name }}
          </td>
          <td>
            {{ ticket.ticket_category ? ticket.ticket_category.category : ticket.ticket_category }}
          </td>
          <td :class="priorityClass(ticket.priority)">
            {{ ticket.priority }}
          </td>
          <td>
            {{ ticket.status }}
          </td>
          <td>
            {{ format(parse(ticket.exp_solution_date)) }}
          </td>
          <td v-if="editable">
            <div class="buttons buttons-right">
              <button
                @click.stop="launchConfirmDelete(ticket.id)" 
                class="button is-small">
                <span class="icon has-text-grey">
                  <i class="fa fa-trash"></i>
                </span>
                <span>Delete</span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

    <v-confirm-modal 
      v-model="confirmDelete.state"
      :title="confirmDelete.title"
      :message="confirmDelete.message"
      :type="confirmDelete.type"
      @confirm="deleteConfirmedCb ? deleteConfirmedCb() : null"
      @cancel="confirmDelete.state = false"/>

  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
import VConfirmModal from '@/components/base/VConfirmModal'

import { mapState, mapActions, mapMutations } from 'vuex'
import { parseISO, format, differenceInDays } from 'date-fns'

export default {
  components: { VPagination, VConfirmModal },
  data() {
    return {
      headers: [
        { label: 'Date Submitted' },
        { label: 'Days Since Submission' },
        { label: 'Submitted By' },
        { label: 'Assigned To' },
        { label: 'Category' },
        { label: 'Priority' },
        { label: 'Status' },
        { label: 'Expected Solution Date' }
      ],
      parse: (d) => {
        return d ? parseISO(d) : null
      },
      format: (d) => {
        return d ? format(d, 'yyyy-MM-dd H:mm:ss') : null
      },
      diffToday: (d) => {
        return d ? differenceInDays(new Date(), d) : null
      },
      confirmDelete: {
        state: false,
        title: 'Delete Confirmation',
        message: 'Are you sure you want to delete this ticket?',
        type: 'danger'
      },
      deleteConfirmedCb: null
    }
  },
  computed: {
    ...mapState("tickets", {
      tickets: "tickets",
      pagination: "ticketPagination"
    }),
    ...mapState("auth", ["user"]),
    editable({ user }) {
      return user.role == 'office-manager' || user.permission == 'admin'
    }
  },
  watch: {
    'pagination.page'(page) {
      this.getTickets({ page: page });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("tickets", ["getTickets", "deleteTicket"]),
    ...mapMutations("tickets", {
      changePage: "changeTicketPage"
    }),
    initialize() {
      this.getTickets();
    },
    updateTicket(ticket) {
      this.$router.push(
        { 
          name: 'TicketViewer', 
          params: { ticketId: ticket.id, ticket: ticket }
        }
      );
    },
    priorityClass(priority) {
      if (!priority) {
        return null
      } else {
        if (priority.toLowerCase() == 'high') {
          return 'is-danger'
        } else if (priority.toLowerCase() == 'medium') {
          return 'is-warning'
        } else {
          return 'has-background-white-ter'
        }
      }
    },
    launchConfirmDelete(id) {
      this.deleteConfirmedCb = () => {
        this.deleteTicket(id);
        this.confirmDelete.state = false;
      }
      this.confirmDelete.state = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
</style>